import { FC } from 'react';
import { navigate } from 'gatsby';
import classNames from 'classnames';
import { IconButton, useDrawer } from '@lambdacurry/component-library';
import { useMeQuery } from 'lib/home/generated/queries';
import { Logo } from '../Logo/Logo';
import { Container } from 'lib/ui-components/src';

interface HeaderProps {
  backTo?: string | (() => void);
}

export const Header: FC<HeaderProps> = ({ backTo }) => {
  const { drawerActions } = useDrawer();
  const { data } = useMeQuery(undefined, {
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
  const me = data?.me;
  const impersonating = me?.impersonating;
  const toggleSideNav = () => drawerActions.toggleDrawer({ name: 'side-nav' });

  return (
    <header className={classNames('bg-white', { 'bg-red-400': impersonating })}>
      <Container>
        <div className="flex justify-center items-center relative py-6">
          {backTo ? (
            <IconButton
              data-cy="back-button"
              className="absolute left-0"
              icon="arrowLeft"
              aria-label="go back"
              onClick={typeof backTo === 'string' ? () => navigate(backTo) : backTo}
            />
          ) : (
            <IconButton
              className="absolute left-0"
              icon="menu"
              aria-label="open side navigation"
              onClick={toggleSideNav}
            />
          )}

          <Logo />

          {impersonating && (
            <span className="impersonating-user text-right font-bold absolute right-0 pr-1">
              Impersonating <br></br> {`${me.first_name} ${me.last_name}`}
            </span>
          )}
        </div>
      </Container>
    </header>
  );
};
